import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import LoadingSpinner from '../common/LoadingSpinner'; // Assurez-vous que le chemin est correct

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const GeneralStats = () => {
    const [timeFilter, setTimeFilter] = useState('week'); // 'week', 'month', 'year'
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchStats = async () => {
            setLoading(true);
            setError(null);
            try {
                                const response = await fetch(`https://back-desalpe.onrender.com/api/anonymous-clicks/general-stats?timeFilter=${timeFilter}`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setStats(data);
            } catch (error) {
                setError('Impossible de charger les statistiques. Veuillez réessayer plus tard.');
                console.error("Failed to fetch stats:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, [timeFilter]);

    const chartData = {
        labels: stats?.data?.map((item) => item.label) || [],
        datasets: [
            {
                label: "Nous rejoindre",
                data: stats?.data?.map((item) => item.clicks) || [],
                borderColor: "rgb(255, 99, 132)",
                backgroundColor: "rgba(255, 99, 132, 0.5)",
                tension: 0.4,
            },
            {
                label: "Formulaires Soumis",
                data: stats?.data?.map((item) => item.forms) || [],
                borderColor: "rgb(53, 162, 235)",
                backgroundColor: "rgba(53, 162, 235, 0.5)",
                tension: 0.4,
            },
            {
                label: "Paiement Effectué",
                data: stats?.data?.map((item) => item.paid) || [],
                borderColor: "rgb(40, 167, 69)",
                backgroundColor: "rgba(40, 167, 69, 0.5)",
                tension: 0.4,
            },
            {
                label: "Paiement en Attente",
                data: stats?.data?.map((item) => item.pending) || [],
                borderColor: "rgb(255, 193, 7)",
                backgroundColor: "rgba(255, 193, 7, 0.5)",
                tension: 0.4,
            },
            {
                label: "Non Intéressé",
                data: stats?.data?.map((item) => item.not_interested) || [],
                borderColor: "rgb(220, 53, 69)",
                backgroundColor: "rgba(220, 53, 69, 0.5)",
                tension: 0.4,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: `Performance des Clics et Formulaires (${timeFilter})`,
            },
        },
    };

    if (loading) {
        return <LoadingSpinner />;
    }

    if (error) {
        return <div className="error-message">{error}</div>;
    }

    return (
        <div className="general-stats-container">
            <h3>Statistiques Générales</h3>
            <div className="filter-bar">
                <span>Période:</span>
                <button
                    onClick={() => setTimeFilter("week")}
                    className={timeFilter === "week" ? "active" : ""}
                >
                    Semaine
                </button>
                <button
                    onClick={() => setTimeFilter("month")}
                    className={timeFilter === "month" ? "active" : ""}
                >
                    Mois
                </button>
                <button
                    onClick={() => setTimeFilter("year")}
                    className={timeFilter === "year" ? "active" : ""}
                >
                    Année
                </button>
            </div>

            {stats && (
                <>
                    <div className="stats-summary">
                        <div className="stat-card">
                            <h4>Formulaires Soumis</h4>
                            <p>{stats.formsSubmitted}</p>
                        </div>
                        <div className="stat-card">
                            <h4>Total Clics nous rejoindre </h4>
                            <p>{stats.clicks}</p>
                        </div>
                        <div className="stat-card">
                            <h4>Paiement Effectué</h4>
                            <p>{stats.buttonClicks.paid}</p>
                        </div>
                        <div className="stat-card">
                            <h4>Paiement en Attente</h4>
                            <p>{stats.buttonClicks.pending}</p>
                        </div>
                        <div className="stat-card">
                            <h4>Non Intéressé</h4>
                            <p>{stats.buttonClicks.not_interested}</p>
                        </div>
                    </div>

                    <div className="graph-container">
                        <Line options={chartOptions} data={chartData} />
                    </div>

                    <div className="mini-table-container links-table-container">
                        <h4>Détail par Période</h4>
                        <table>
                            <thead>
                                <tr>
                                    <th>Période</th>
                                    <th>Clics Totaux</th>
                                    <th>Formulaires</th>
                                    <th>Paiement Effectué</th>
                                    <th>Paiement en Attente</th>
                                    <th>Non Intéressé</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stats.data.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.label}</td>
                                        <td>{item.clicks}</td>
                                        <td>{item.forms}</td>
                                        <td>{item.paid}</td>
                                        <td>{item.pending}</td>
                                        <td>{item.not_interested}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </div>
    );
};


export default GeneralStats;
